// @module Tavanoteam.HazardousProducts.HideHazmatFee
define('Tavanoteam.HazardousProducts.HideHazmatFee.View'
	, [
		'Backbone'
	]
	, function (
		Backbone
	) {
		'use strict';

		// @class Tavanoteam.HazardousProducts.HideHazmatFee.View @extends Backbone.View
		return Backbone.View.extend({

			initialize: function (options) {

				/*  Uncomment to test backend communication with an example service
					(you'll need to deploy and activate the extension first)
				*/

				// this.model = new HideHazmatFeeModel();
				// var self = this;
				// this.model.fetch().done(function(result) {
				// 	self.message = result.message;
				// 	self.render();
				// });
			}

			, events: {
			}

			, bindings: {
			}

			, childViews: {

			}

			//@method getContext @return Tavanoteam.HazardousProducts.HideHazmatFee.View.Context
			, getContext: function getContext() {
				//@class Tavanoteam.HazardousProducts.HideHazmatFee.View.Context
				this.message = this.message || 'Hello World!!'
				return {
					message: this.message
				};
			}
		});
	});
